/**
 * pz.utilityModals
 * 
 * Controls utility modals in header area (account, cart, and search)
 * 
 * Requires: jquery
 */

$(function () {
    'use strict';

    if (window.pz === undefined) {
        window.pz = {};
    }

    pz.utilityModals = function () {

        var initModule = function () {

            // Search modal
            $('.js-search-icon').on('click', function (event) {
                handleModal($('.js-search-modal'));
            });

            // Account menu modal
            $('.js-account-icon').on('click', function (event) {
                handleModal($('.js-account-modal'));
            });

            // Cart Modal
            $('.js-cart-icon').on('click', function (event) {
                handleModal($('.js-cart-modal'));
            });

            // Close modals when clicking anywhere outside modal
            $(document).on('click', function (event) {
                if (!$(event.target).closest('.js-search-icon').length && !$(event.target).closest('.js-search-modal').length) {
                    closeModal($('.js-search-modal'));
                }
                if (!$(event.target).closest('.js-account-icon').length && !$(event.target).closest('.js-account-modal').length) {
                    closeModal($('.js-account-modal'));
                }
                if (!$(event.target).closest('.js-cart-icon').length && !$(event.target).closest('.js-cart-modal').length) {
                    closeModal($('.js-cart-modal'));
                }
            });

            // Handle cart modal view cart button
            // Note: need to target element that does not get reloaded
            $('.js-cart-modal').on('click', '.js-cart-modal-view-cart-button', function (event) {
                event.preventDefault();
                closeModal($('.js-cart-modal'));
                window.location.href = '/cart';
            });
        };

        var handleModal = function handleModal($modal) {
            if ($modal.is('.active')) {
                closeModal($modal);
            } else {
                openModal($modal);
            }
        };

        var closeModal = function closeModal($modal) {
            $modal.removeClass('active');
            $modal.fadeOut(250);
        };

        var openModal = function openModal($modal) {
            $modal.addClass('active');
            $modal.fadeIn(250);
        };

        return {
            initModule: initModule
        };
    }();

    pz.utilityModals.initModule();
});